import { createAction } from '@reduxjs/toolkit'
import {
  type AddActiveFilterPayload,
  type AddActiveLabelPayload,
  type RemoveActiveFilterPayload,
  type RemoveActiveLabelFilterPayload,
  type SetAlarmsFilterPayload
} from './meter-table-types'
import { type CompanyAlarm } from '../companies/companies-types'

/* Action Types */

const ADD_ACTIVE_FILTER = 'ADD_ACTIVE_FILTER'
const ADD_ACTIVE_LABEL_FILTER = 'ADD_ACTIVE_LABEL_FILTER'
const CLOSE_REMOVE_METER_DIALOG = 'CLOSE_REMOVE_METER_DIALOG'
const OPEN_REMOVE_METER_DIALOG = 'OPEN_REMOVE_METER_DIALOG'
const REMOVE_ACTIVE_FILTER = 'REMOVE_ACTIVE_FILTER'
const REMOVE_ACTIVE_LABEL_FILTER = 'REMOVE_ACTIVE_LABEL_FILTER'
const SEARCH_METERS_DATA_ACTION = 'SEARCH_METERS_DATA_ACTION'
const SEARCH_STRING_CHANGED = 'SEARCH_STRING_CHANGED'
const SET_ALARMS_FILTER = 'SET_ALARMS_FILTER'
const SET_COMPANY_ALARM = 'SET_COMPANY_ALARM'
const SET_EDIT_COMPANY_ALARMS_DIALOG_VISIBILITY = 'SET_EDIT_COMPANY_ALARMS_DIALOG_VISIBILITY'
const SET_METER_ACTIVE_PAGE = 'SET_METER_ACTIVE_PAGE'
const SET_METER_PAGE_SIZE = 'SET_METER_PAGE_SIZE'
const TOGGLE_DOWNLOAD_DIALOG = 'TOGGLE_DOWNLOAD_DIALOG'
const TOGGLE_REMOVE_METER_CONFIRMED = 'TOGGLE_REMOVE_METER_CONFIRMED'
const TOGGLE_METER_SETTINGS_DIALOG = 'TOGGLE_METER_SETTINGS_DIALOG'

/* Action Creators */

export const ToggleDownloadDialogAction = createAction(TOGGLE_DOWNLOAD_DIALOG)
export const ToggleMeterSettingsDialogAction = createAction(TOGGLE_METER_SETTINGS_DIALOG)

export const SetMeterActivePageAction = createAction<{ activePage: number }>(SET_METER_ACTIVE_PAGE)
export const SetMeterPageSizeAction = createAction<{ pageSize: number }>(SET_METER_PAGE_SIZE)
export const SearchMetersDataAction = createAction<string>(SEARCH_METERS_DATA_ACTION)
export const ToggleRemoveMeterConfirmedAction = createAction(TOGGLE_REMOVE_METER_CONFIRMED)
export const OpenRemoveMeterDialogAction = createAction(OPEN_REMOVE_METER_DIALOG)
export const CloseRemoveMeterDialogAction = createAction(CLOSE_REMOVE_METER_DIALOG)

export const RemoveActiveLabelFilterAction = createAction<RemoveActiveLabelFilterPayload>(REMOVE_ACTIVE_LABEL_FILTER)
export const AddActiveLabelAction = createAction<AddActiveLabelPayload>(ADD_ACTIVE_LABEL_FILTER)
export const RemoveActiveFilterAction = createAction<RemoveActiveFilterPayload>(REMOVE_ACTIVE_FILTER)
export const AddActiveFilterAction = createAction<AddActiveFilterPayload>(ADD_ACTIVE_FILTER)
export const SetAlarmsFilterAction = createAction<SetAlarmsFilterPayload>(SET_ALARMS_FILTER)
export const SearchStringChangedAction = createAction<string>(SEARCH_STRING_CHANGED)

export const SetCompanyAlarmDialogVisibilityAction = createAction<boolean>(SET_EDIT_COMPANY_ALARMS_DIALOG_VISIBILITY)
export const SetCompanyAlarmAction = createAction<CompanyAlarm>(SET_COMPANY_ALARM)
